"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHead = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableCellContext = require("../TableCell/TableCellContext");

var _excluded = ["children", "className", "isSticky", "offsetTop", "testId"];
var styles = {
  "TableHead--sticky": "TableHead__TableHead--sticky___1YzE0"
};

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky,
      offsetTop = _ref.offsetTop,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-table-head' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, styles["TableHead--sticky"], isSticky));

  if (isSticky) {
    _TableCellContext.contextOptions.head.offsetTop = offsetTop || 0;
  }

  return /*#__PURE__*/_react["default"].createElement(_TableCellContext.TableCellContext.Provider, {
    value: _TableCellContext.contextOptions.head
  }, /*#__PURE__*/_react["default"].createElement("thead", (0, _extends2["default"])({
    className: classNames,
    "data-test-id": testId
  }, otherProps), children));
};

exports.TableHead = TableHead;